import { c as _c } from "react/compiler-runtime";
import { useProfileItemsSelectionStore } from "@/components/items/profile/ProfileItemsSelectionProvider";
export function useProfileItemSelectionIndex(itemId) {
  const $ = _c(4);
  const selectedItemsMap = useProfileItemsSelectionStore(_temp);
  if (!(itemId && selectedItemsMap.has(itemId))) {
    return -1;
  }
  let index = 0;
  let t0;
  if ($[0] !== index || $[1] !== itemId || $[2] !== selectedItemsMap) {
    t0 = Symbol.for("react.early_return_sentinel");
    bb0: for (const key of selectedItemsMap.keys()) {
      if (key === itemId) {
        t0 = index;
        break bb0;
      }
      index++;
    }
    $[0] = index;
    $[1] = itemId;
    $[2] = selectedItemsMap;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  if (t0 !== Symbol.for("react.early_return_sentinel")) {
    return t0;
  }
  return -1;
}
function _temp(state) {
  return state.selectedItemsMap;
}